module.exports = __webpack_public_path__ + "assets/img/a452-ea.svg";